import { BaseContainerModel } from '../base-container.model';
import {
    bl_fi_generic_doc_link_RowClass,
  bl_fi_generic_doc_link_RowInterface,
} from '../../dbschema/index';

export class GenDocLinkContainerModel extends BaseContainerModel {
  bl_fi_generic_doc_link: bl_fi_generic_doc_link_RowClass = new bl_fi_generic_doc_link_RowClass();
}
